import type { ResumeExperience } from 'types/resume';
import styles from './EducationSection.module.scss';

interface Props {
  entries: ResumeExperience[];
}

function formatYear(d: string): string {
  if (!d) return '';
  if (d === 'present') return 'Present';
  return d.split('-')[0];
}

function formatRange(start: string, end: string): string {
  const startYear = formatYear(start);
  const endYear   = formatYear(end);
  if (!endYear || endYear === startYear) return startYear;
  return `${startYear} – ${endYear}`;
}

export default function EducationSection({ entries }: Props) {
  if (!entries.length) return null;

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Education</h2>
      <div className={styles.list}>
        {entries.map(entry => (
          <div key={entry.slug} className={styles.entry}>
            <div className={styles.entryMain}>
              <div className={styles.degree}>{entry.title}</div>
              <div className={styles.org}>{entry.organization}</div>
            </div>
            <div className={styles.entryMeta}>
              <span>{formatRange(entry.start, entry.end)}</span>
              {entry.location && <span>{entry.location}</span>}
            </div>
            {entry.summary && (
              <p className={styles.summary}>{entry.summary}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
